<su-headline h="h1" skin="primary">{{ title }}</su-headline>
<su-headline h="h2" skin="primary"
  ><div
    style="font-size: large; line-height: 2"
    [innerHtml]="message | safeHtml"></div>
</su-headline>
